import type { Language } from "../strings";

export interface PopularQuestionSet {
  book: string;
  chapter: number;
  questions: { es: string; en: string }[];
}

/**
 * Operator-curated, doctrinally distinct prompts. Review monthly against the
 * aggregate topic table; never collapse a chapter into one cacheable intent.
 */
export const POPULAR_QUESTION_SETS: PopularQuestionSet[] = [
  {
    book: "juan",
    chapter: 5,
    questions: [
      { es: "¿Qué enseña Koresh sobre la sanidad de Juan 5?", en: "What does Koresh teach about the healing in John 5?" },
      { es: "¿Qué significa que el Hijo no puede hacer nada por sí mismo en Juan 5?", en: "What does John 5 mean when it says the Son can do nothing by himself?" },
      { es: "¿Cómo conecta Juan 5 la resurrección con el juicio?", en: "How does John 5 connect resurrection and judgment?" },
      { es: "¿Cuáles son los testigos mencionados en Juan 5?", en: "Who are the witnesses mentioned in John 5?" },
    ],
  },
  {
    book: "apocalipsis",
    chapter: 12,
    questions: [
      { es: "¿Quién es la mujer de Apocalipsis 12 según Koresh?", en: "Who is the woman in Revelation 12 according to Koresh?" },
      { es: "¿Qué representa el dragón de Apocalipsis 12?", en: "What does the dragon in Revelation 12 represent?" },
      { es: "¿Cómo conecta Apocalipsis 12 con Génesis 3?", en: "How does Revelation 12 connect with Genesis 3?" },
    ],
  },
  {
    book: "apocalipsis",
    chapter: 6,
    questions: [
      { es: "¿Qué enseña Koresh sobre los cuatro jinetes?", en: "What does Koresh teach about the four horsemen?" },
      { es: "¿Por qué el primer sello es positivo?", en: "Why is the first seal positive?" },
      { es: "¿Qué representan el caballo negro y la balanza?", en: "What do the black horse and the scales represent?" },
      { es: "¿Qué enseña Koresh sobre el cuarto sello?", en: "What does Koresh teach about the fourth seal?" },
    ],
  },
  {
    book: "apocalipsis",
    chapter: 11,
    questions: [
      { es: "¿Quiénes son los dos testigos de Apocalipsis 11?", en: "Who are the two witnesses in Revelation 11?" },
      { es: "¿Cómo se conecta Apocalipsis 11 con Eliyahu y Moshe?", en: "How does Revelation 11 connect with Eliyahu and Moshe?" },
      { es: "¿Qué significa medir el templo en Apocalipsis 11?", en: "What does measuring the temple in Revelation 11 mean?" },
    ],
  },
  {
    book: "genesis",
    chapter: 1,
    questions: [
      { es: "¿Qué enseña Koresh sobre los días de la creación?", en: "What does Koresh teach about the days of creation?" },
      { es: "¿Qué significa la luz de Génesis 1 antes del sol?", en: "What is the light in Genesis 1 before the sun?" },
      { es: "¿Cómo interpreta Koresh 'hagamos al hombre a nuestra imagen'?", en: "How does Koresh interpret 'let us make man in our image'?" },
      { es: "¿Qué conexiones proféticas encuentra Koresh en Génesis 1?", en: "What prophetic connections does Koresh find in Genesis 1?" },
    ],
  },
  {
    book: "genesis",
    chapter: 2,
    questions: [
      { es: "¿Qué enseña Koresh sobre la creación de Adán en Génesis 2?", en: "What does Koresh teach about the creation of Adam in Genesis 2?" },
      { es: "¿Qué significa el jardín del Edén según Koresh?", en: "What does the garden of Eden mean according to Koresh?" },
      { es: "¿Qué enseña Koresh sobre el aliento de vida y el alma?", en: "What does Koresh teach about the breath of life and the soul?" },
    ],
  },
  {
    book: "juan",
    chapter: 4,
    questions: [
      { es: "¿Qué enseña Koresh sobre la mujer samaritana en Juan 4?", en: "What does Koresh teach about the Samaritan woman in John 4?" },
      { es: "¿Qué significa el agua viva en Juan 4?", en: "What does the living water in John 4 mean?" },
      { es: "¿Qué enseña Koresh sobre adorar en espíritu y en verdad?", en: "What does Koresh teach about worshipping in spirit and truth?" },
    ],
  },
  {
    book: "juan",
    chapter: 9,
    questions: [
      { es: "¿Qué enseña Koresh sobre el ciego de nacimiento en Juan 9?", en: "What does Koresh teach about the man born blind in John 9?" },
      { es: "¿Por qué Yahushua sana con lodo y saliva en Juan 9?", en: "Why does Yahushua heal with clay and saliva in John 9?" },
      { es: "¿Qué significa la ceguera espiritual en Juan 9?", en: "What does spiritual blindness mean in John 9?" },
    ],
  },
  {
    book: "apocalipsis",
    chapter: 2,
    questions: [
      { es: "¿Qué enseña Koresh sobre las cartas a las siete iglesias?", en: "What does Koresh teach about the letters to the seven assemblies?" },
      { es: "¿Quiénes son los nicolaítas en Apocalipsis 2?", en: "Who are the Nicolaitans in Revelation 2?" },
      { es: "¿Qué significa comer del árbol de la vida en Apocalipsis 2?", en: "What does eating from the tree of life in Revelation 2 mean?" },
    ],
  },
  {
    book: "1cronicas",
    chapter: 16,
    questions: [
      { es: "¿Qué enseña Koresh sobre el sacrificio continuo y la abominación desoladora?", en: "What does Koresh teach about the continual sacrifice and the abomination of desolation?" },
      { es: "¿Qué representan el pan, la carne y las tortas de pasas en 1 Crónicas 16?", en: "What do the bread, the meat and the raisin cakes represent in 1 Chronicles 16?" },
      { es: "¿Qué son los elil y los falsos elohim según Koresh?", en: "What are the elil and the false elohim according to Koresh?" },
      { es: "¿Qué significa invocar el Nombre en 1 Crónicas 16?", en: "What does it mean to call upon the Name in 1 Chronicles 16?" },
    ],
  },
  {
    book: "apocalipsis",
    chapter: 1,
    questions: [
      { es: "¿Qué enseña Koresh sobre los nombres verdaderos en Apocalipsis 1?", en: "What does Koresh teach about the true names in Revelation 1?" },
      { es: "¿Quiénes son los siete espíritus delante del trono?", en: "Who are the seven spirits before the throne?" },
      { es: "¿Por qué se llama a Yahushua el testigo fiel y el primogénito?", en: "Why is Yahushua called the faithful witness and the firstborn?" },
      { es: "¿Qué significa que nos hizo reyes y sacerdotes?", en: "What does it mean that he made us kings and priests?" },
    ],
  },
  {
    book: "juan",
    chapter: 8,
    questions: [
      { es: "¿Por qué el testimonio de Yahushua es verdadero en Juan 8?", en: "Why is Yahushua's testimony true in John 8?" },
      { es: "¿Qué significa juzgar según la carne en Juan 8?", en: "What does it mean to judge according to the flesh in John 8?" },
      { es: "¿Qué enseña Koresh sobre el testimonio de dos?", en: "What does Koresh teach about the testimony of two?" },
      { es: "¿Qué quiso decir Yahushua con «yo me voy y me buscaréis»?", en: "What did Yahushua mean by 'I go away, and you will seek me'?" },
    ],
  },
  {
    book: "exodo",
    chapter: 12,
    questions: [
      { es: "¿Qué representan las ovejas y las cabras en Éxodo 12?", en: "What do the sheep and the goats represent in Exodus 12?" },
      { es: "¿Qué significa «entre las dos tardes» según Koresh?", en: "What does 'between the two evenings' mean according to Koresh?" },
      { es: "¿Por qué Aviv es la cabeza del año?", en: "Why is Aviv the head of the year?" },
      { es: "¿Qué enseña Koresh sobre el calendario falso de Egipto?", en: "What does Koresh teach about Egypt's false calendar?" },
    ],
  },
];

export function popularQuestions(language: Language, book?: string, chapter?: number): string[] {
  // Reader: the questions curated for this specific chapter (or none).
  if (book && chapter) {
    const set = POPULAR_QUESTION_SETS.find(
      (s) => s.book === book.toLowerCase() && s.chapter === chapter,
    );
    return set ? set.questions.map((question) => question[language]).slice(0, 4) : [];
  }
  // Home fallback: ONE representative question per topic for variety — never
  // several from the same chapter (which read as repetitive).
  return POPULAR_QUESTION_SETS.slice(0, 4)
    .map((set) => set.questions[0])
    .filter((question): question is { es: string; en: string } => question !== undefined)
    .map((question) => question[language]);
}

export interface PopularTopic {
  book: string;
  chapter: number;
}

/**
 * Day index since the epoch — the default rotation seed. Exported so the smoke
 * can pin it; UTC-based so every visitor sees the same strip on a given day.
 */
export function rotationIndex(now: Date = new Date()): number {
  return Math.floor(now.getTime() / 86_400_000);
}

/**
 * Home suggestions ranked by REAL demand (from GET /popular-topics): for each
 * hot topic we have a curated question for, take ONE question in demand order;
 * then top up from the curated default so the strip is never sparse — which
 * also makes it the full graceful fallback when analytics are thin or the
 * endpoint is unreachable (topics = []).
 *
 * ROTATION (2026-08-19): this used to take `questions[0]` — the lead — for every
 * set, so of the curated questions only ONE PER CHAPTER could ever be displayed
 * and the home read as frozen no matter what the congregation asked. It now
 * walks the set by a day index, so every curated question is reachable and the
 * strip turns over daily while staying demand-ranked. Same seed for everyone on
 * a given UTC day, so it is stable within a session and testable.
 */
export function rankedHomeQuestions(
  language: Language,
  topics: readonly PopularTopic[],
  limit = 6,
  rotation: number = rotationIndex(),
): string[] {
  const byKey = new Map<string, PopularQuestionSet>();
  for (const set of POPULAR_QUESTION_SETS) byKey.set(`${set.book}-${set.chapter}`, set);

  const out: string[] = [];
  const seen = new Set<string>();
  const push = (set: PopularQuestionSet | undefined): void => {
    if (set === undefined || set.questions.length === 0) return;
    const offset = ((rotation % set.questions.length) + set.questions.length) % set.questions.length;
    const chosen = set.questions[offset];
    if (chosen === undefined) return;
    const text = chosen[language];
    if (seen.has(text)) return;
    seen.add(text);
    out.push(text);
  };

  for (const topic of topics) {
    if (out.length >= limit) break;
    push(byKey.get(`${topic.book.toLowerCase()}-${topic.chapter}`));
  }
  for (const set of POPULAR_QUESTION_SETS) {
    if (out.length >= limit) break;
    push(set);
  }
  return out.slice(0, limit);
}

